import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import { LabelSelection } from '../LabelSelection';
import { StepHeader } from '../StepHeader';
import { getStepStatus, toggleStep } from '../../utils/rankAListHelpers';
import { ColumnInfo } from '../../types/rankAList';
import { exampleColumns, exampleLabels } from '../../data/rankAListExamples';

interface LabelSelectionStepProps {
  step: number;
  expandedSteps: number[];
  setExpandedSteps: (steps: number[]) => void;
  columns: ColumnInfo[];
  labelColumn: string;
  availableLabels: string[];
  positiveLabels: string[];
  negativeLabels: string[];
  onLabelColumnChange: (column: string) => void;
  onPositiveLabelsChange: (labels: string[]) => void;
  onNegativeLabelsChange: (labels: string[]) => void;
}

export const LabelSelectionStep: React.FC<LabelSelectionStepProps> = ({
  step,
  expandedSteps,
  setExpandedSteps,
  columns,
  labelColumn,
  availableLabels,
  positiveLabels,
  negativeLabels,
  onLabelColumnChange,
  onPositiveLabelsChange,
  onNegativeLabelsChange
}) => {
  const isOpen = expandedSteps.includes(5);
  
  const getTitle = () => {
    if (step > 5 && labelColumn && positiveLabels.length > 0) {
      const labels = positiveLabels.join(', ');
      return (
        <span>
          Select Labels: <span className="text-slate-400">{labelColumn} ({labels})</span>
        </span>
      );
    }
    return 'Select Labels';
  };
  
  return (
    <Collapsible 
      open={isOpen} 
      className="border border-slate-600 rounded-lg bg-slate-800"
    >
      <CollapsibleTrigger asChild>
        <button className="w-full" onClick={() => toggleStep(5, expandedSteps, setExpandedSteps)}>
          <StepHeader 
            stepNumber={5} 
            title={getTitle()} 
            status={getStepStatus(step, 5)}
            isOpen={isOpen}
          />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="px-4 pb-4">
        <LabelSelection 
          columns={step >= 5 ? columns : exampleColumns}
          labelColumn={step >= 5 ? labelColumn : 'category'}
          availableLabels={step >= 5 ? availableLabels : exampleLabels}
          positiveLabels={step >= 5 ? positiveLabels : ['B2B', 'Enterprise']}
          negativeLabels={step >= 5 ? negativeLabels : ['B2C']}
          onLabelColumnChange={onLabelColumnChange}
          onPositiveLabelsChange={onPositiveLabelsChange}
          onNegativeLabelsChange={onNegativeLabelsChange}
          disabled={step > 5}
        />
      </CollapsibleContent>
    </Collapsible>
  );
}; 